import { render, staticRenderFns } from "./MessageContainer.vue?vue&type=template&id=66dc12b4"
import script from "./MessageContainer.vue?vue&type=script&lang=js"
export * from "./MessageContainer.vue?vue&type=script&lang=js"
import style0 from "./MessageContainer.vue?vue&type=style&index=0&id=66dc12b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports